import React, { useState, useEffect } from 'react';
import AdminUsers from './AdminUsers';

function Admin({ state, setState }) {

    const [option, setOption] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='modal_body'>
            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={() => setOption(<AdminUsers state={state} setState={setState} />)}>Users</button>
                </div>
            </div>
            {option}
        </div>
    );
}

export default Admin;